import React from "react";
import useCreateUserForm from "./useCreateUserForm";
import UserForm from "../UserForm";
import Resources from "../../../types/Resources";
import { DepartmentRoleOptions } from "../../../types/DepartmentRoleOptions";

export type CreateUserFormProps = {
    resources: Resources;
    departmentRoleOptions: DepartmentRoleOptions[];
};

function CreateUserForm(props: CreateUserFormProps) {
    const pageContent = useCreateUserForm(props);

    return (
        <UserForm
            resources={props.resources}
            departmentRoleOptions={props.departmentRoleOptions}
            onFirstNameChange={pageContent.handleFirstNameChange}
            onLastNameChange={pageContent.handleLastNameChange}
            onEmailChange={pageContent.handleEmailChange}
            onPhoneNumberChange={pageContent.handlePhoneNumberChange}
            onPasswordChange={pageContent.handlePasswordChange}
            onConfirmationPasswordChange={pageContent.handleConfirmationPasswordChange}
            onReceivesSmsChange={pageContent.handleReceivesSmsChange}
            submitButtonText={props.resources.get("CreateUser") ?? ""}
            onNewCompanyNameChange={pageContent.handleNewCompanyNameChange}
            onNewCompanyDepartmentNameChange={pageContent.handleNewDepartmentNameChange}
            onRoleRemoved={pageContent.handleRoleRemoved}
            onHideNewCompanyInputs={pageContent.handleHideNewCompanyInputs}
            formState={pageContent.formState}
            onHideNewCompanyDepartmentInput={pageContent.handleHideNewCompanyDepartmentInput}
            onRoleAdded={pageContent.handleNewRoleAdded}
            onShowNewCompanyInputs={pageContent.handleShowNewCompanyInputs}
            onShowNewCompanyDepartmentInput={pageContent.handleShowNewCompanyDepartmentInput}
            showNewCompanyInputs={pageContent.showNewCompanyInputs}
            showNewCompanyDepartmentInput={pageContent.showNewCompanyDepartmentInput}
            onHideNewUserRoleRow={pageContent.handleHideNewUserRoleRow}
            onShowNewUserRoleRow={pageContent.handleShowNewUserRoleRow}
            showNewUserRoleRow={pageContent.showNewUserRoleRow}
            companyDepartmentOptions={pageContent.companyDepartmentOptions}
            companyOptions={pageContent.companyOptions}
            onCompanySearch={pageContent.handleCompanySearchAsync}
            onCompanySelected={pageContent.handleCompanySelected}
            onCompanyRemoved={pageContent.handleCompanyRemoved}
            onCompanyDepartmentRemoved={pageContent.handleCompanyDepartmentRemoved}
            onCompanyDepartmentSelected={pageContent.handleCompanyDepartmentSelected}
            onSubmit={pageContent.handleSubmitAsync}
        />
    );
}

export default CreateUserForm;
